/**
 * Decides how much of a failure a generated app reveals to its end user. Default is
 * {@link EErrorMessageMode.Detailed} so existing projects — which have no
 * `errorMessageMode` field persisted — keep their current behavior unchanged.
 *
 * `Simple` replaces the body of any 5xx response with a generic, localized message,
 * which is what stops database, SMTP, REST and custom-C# text from reaching a toast.
 * Messages a developer wrote deliberately (the 4xx family, e.g. KBadRequestException)
 * are still returned verbatim. Neither mode changes what is written to KLog: the full
 * message and stack trace are recorded either way.
 */
export enum EErrorMessageMode {
  Detailed = 0,
  Simple = 1
}
